import './member-status.scss'
import { Icon, MemberContextComponent } from '@vista-digital/occ-ui'
import { observer } from 'mobx-react-lite'
import type { FC } from 'react'
import { NavLink } from 'react-router-dom-v7'
import { navigationService } from '@/content/services/navigation.service'
import { useMemberInitials } from '../../../../../common/hooks/useMemberInitials'
import { useLoadMember } from './hooks/useLoadMember'
import { NotificationsCount } from './subcomponents/NotificationsCount'

export const MemberStatus: FC = observer(() => {
    const { signedIn, memberName } = useLoadMember()
    const signInOrSignUpPage = navigationService.getPageUrl('SignInOrSignUp')
    const accountHomePath = navigationService.getPageUrl('AccountHome')

    const initials = useMemberInitials(memberName)

    return (
        <div className="header-sign">
            {!signedIn && (
                <div className="signed-out-icon">
                    <NavLink to={signInOrSignUpPage} className="signed-out-link">
                        <Icon name="profile" />
                    </NavLink>
                </div>
            )}

            {signedIn && (
                <MemberContextComponent>
                    <div className="signed-in-icon">
                        <NavLink to={accountHomePath} className="signed-in-link">
                            <span className="initials">{initials}</span>
                        </NavLink>
                        <NotificationsCount />
                    </div>
                </MemberContextComponent>
            )}
        </div>
    )
})
